{
  "version": 1,
  "asset_id": "cdfe298c-6210-40ba-9fd7-0d1dd4a70b59",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/cdfe298c-6210-40ba-9fd7-0d1dd4a70b59/bypass-revision-downsizing-es.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/cdfe298c-6210-40ba-9fd7-0d1dd4a70b59/bypass-revision-downsizing-es.webp",
  "original_filename": "bypass-revision-downsizing-es.webp",
  "size": 223680,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:24Z"
}
